/**
 * 画面描述匹配度(clip skip)
 */

import { clipSkipAtom } from './atom'
import { createSliderInputComponent } from './_createSliderInputComponent'

const ClipSkipComp = createSliderInputComponent(
  {
    label: 'Clip skip',
    atom: clipSkipAtom,
    helpContent:
      '画面描述匹配度（Clip skip）的值表示你希望画面描述对于模型主题来说匹配的准确度',
    min: 1,
    max: 12,
    step: 1,
    digits: 0,
  },
  'ClipSkip'
)

export { ClipSkipComp }
